import SurveyRating from './SurveyRatingContainer';

export default SurveyRating;
